import styled from 'styled-components';

import colors from '../../../../styles/colors';
import { Card } from '../../../../components/v2/Card';

const StyledCard = styled(Card)`
  margin: 20px;
  border: 1px solid ${colors.shades.gamma4};
`;

export {
  StyledCard,
};
